import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";


export const ContainerFullSchema: RegistryItem = {
	[AgreementConditionType.ContainerFull]: {
		toInput: (form) => ({
			empty: form.empty,
		}),
		toForm: (condition) => ({
			empty: condition.empty ?? false,
		}),
	},
};
